import styled from '@emotion/styled'
import Colors from '@figma/panda/Colors'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import FeatherIcon from 'feather-icons-react'
import type { TemplateFeature } from '../types'

interface FeatureItemProps {
  feature: TemplateFeature
  onDelete: (featureId: string) => void
}

export const FeatureItem = ({ feature, onDelete }: FeatureItemProps) => {
  return (
    <StyledFeatureItem>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            cursor: 'pointer',
            flex: 1,
          }}
        >
          <Typography variant="body1" sx={{ color: Colors.baseBlack }}>
            {feature.name}
          </Typography>
          <Typography variant="body1" sx={{ color: Colors.brandBiegeGray400 }}>
            {feature.type === 'boolean' && (feature.value ? 'Active' : 'Inactive')}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '32px',
            marginLeft: '32px',
          }}
        >
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation()
              onDelete(feature.id)
            }}
            data-testid={`delete-feature-${feature.id}`}
          >
            <FeatherIcon icon="trash-2" size={16} />
          </IconButton>
        </Box>
      </Box>
    </StyledFeatureItem>
  )
}

const StyledFeatureItem = styled(Box)`
  padding: 2px 24px;
  background-color: ${Colors.baseWhite};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  
  &:hover {
    background-color: ${Colors.base100};
  }
`
